
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

import AjaxService from '../../Services/Ajax/index.jsx';


class ShowLocked extends React.Component {
  constructor(props) {
    super(props);

    // initialise the state based on the initial value
    this.state = {
      showLocked: props.showLocked
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    this.setState(function(oldState) {
      return { showLocked: ! oldState.showLocked };
    }, this.showLockedChanged);
  }

  /**
    * update the user's 'show locked' setting, and "Reset" the feed, by
    * updating the locked selection, if one was provided
    */
  showLockedChanged() {
    // update the user's setting
    AjaxService.post(
      'cs:feeds--show-locked',
      'show-locked=' + (this.state.showLocked ? '1' : '0')
    );

    // update the feed api service with the user's new setting, if one has
    // been provided
    if (this.props.apiService) {
      this.props.apiService.showLocked(this.state.showLocked);
    }
  }

  render() {
    return (
      <div className="my-2 text-right">
        <Form.Check
          type="switch"
          custom
          id="show-locked"
          label="Show locked articles"
          checked={this.state.showLocked}
          onChange={this.onChange}
        />
      </div>
    );
  }
};


ShowLocked.propTypes = {
  showLocked: PropTypes.bool
};

ShowLocked.defaultProps = {
  showLocked: true
};


export default ShowLocked

